import { render, staticRenderFns } from "./PaymentSummary.vue?vue&type=template&id=70cf191b&scoped=true"
import script from "./PaymentSummary.vue?vue&type=script&lang=js"
export * from "./PaymentSummary.vue?vue&type=script&lang=js"
import style0 from "./PaymentSummary.vue?vue&type=style&index=0&id=70cf191b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf191b",
  null
  
)

export default component.exports